import { useEffect, useRef, useState } from "react";
import loader from "../../../assets/images/loader.gif";
import CollabAlertModal from "../../../components/dashboard/user-dashboard/CollabAlertModal";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import { getAllCollaborators } from "../../../service/DashboardService";
import { AppContext } from "../../../context/AppContext";
import { useContext } from "react";

const UserCollaborators = () => {
  const [collabStatus, setCollabStatus] = useState({});
  const [open, setOpen] = useState(false);
  const { collabStore, setCollabStore } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const topRef = useRef(null);

  useEffect(() => {
    fetchData();
    scrollToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const userId = localStorage.getItem("userId");
      const response = await getAllCollaborators(userId, token);
      // The backend returns a PaginatedResponse structure where the list is inside the 'content' field
      setCollabStore(response?.content || response || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching collaborators:", error);
      setLoading(false);
    }
  };

  const collabApproval = (projectId, collaboratorId, userId) => {
    setCollabStatus({
      ProjectId: projectId,
      Status: "APPROVED",
      CollobaratorId: collaboratorId,
      User: { UserId: userId },
    });
    setOpen(true);
  };

  const collabReject = (projectId, collaboratorId, userId) => {
    setCollabStatus({
      ProjectId: projectId,
      Status: "REJECTED",
      CollobaratorId: collaboratorId,
      User: { UserId: userId },
    });
    setOpen(true);
  };

  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const formatDateTime = (dateTimeString) => {
    const options = {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const dateTime = new Date(dateTimeString);
    return dateTime.toLocaleDateString("en-US", options);
  };

  return (
    <>
      <div ref={topRef}>
        <TopHeader tabName={"Requests for Collaboration"} />
        {loading ? (
          <div className="flex justify-center ">
            <img src={loader} alt="Loading" />
          </div>
        ) : (
          <div className="mt-10">
            <table className="w-full text-sm text-center rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Project Name
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Collaboration Type
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Collaboration Participans
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {(collabStore || []).length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center py-4">
                      No records found
                    </td>
                  </tr>
                ) : (
                  (collabStore || []).map((colla, i) => (
                    <tr className="bg-white dark:bg-gray-800">
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                      >
                        <div className="flex flex-col items-center gap-2">
                          <h1 className="text-gray-900 font-bold mb-4">
                            {colla.ProjectName}
                          </h1>
                          <p>{colla.CollobaratorName} requested for Approval</p>
                        </div>
                      </th>
                      <td className="px-6 py-4">{colla.CollaborationTypes}</td>
                      <td className="px-6 py-4">
                        {colla.CollborationParticipants}
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex flex-col items-center gap-2">
                          <p> {formatDateTime(colla.UploadDateTime)}</p>
                          <div className="flex items-center gap-4">
                            <span
                              className="text-red-500 cursor-pointer"
                              onClick={() =>
                                collabReject(
                                  colla.ProjectId,
                                  colla.CollobaratorId,
                                  colla?.User?.UserId
                                )
                              }
                            >
                              Reject
                            </span>
                            <span
                              className="px-3 py-2 text-xs text-white bg-gradient-to-r from-cyan-200 via-cyan-300 to-cyan-400 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg  text-center me-2 mb-2 cursor-pointer"
                              onClick={() =>
                                collabApproval(
                                  colla.ProjectId,
                                  colla.CollobaratorId,
                                  colla?.User?.UserId
                                )
                              }
                            >
                              Approval
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <CollabAlertModal
        open={open}
        setOpen={setOpen}
        collabStatus={collabStatus}
      />
    </>
  );
};

export default UserCollaborators;
